<template>
  <v-layout column class="code-card">
    <div class="text-xs-center font-weight-regular headline">Supply Chain Information</div>
    <div class="text-xs-center caption">{{transaction.code.serialNumber}}</div>
    <v-layout column class="px-3 py-2">
      <template v-for="field in scmFields">
        <template v-if="!field.immutable || type == 'COMPLETED_TRANSACTIONS'">
          <div :key="field.key + '-key'" class="label text-uppercase font-weight-bold px-3 py-2">{{field.label}}:</div>
          <div :key="field.key + '-val'" class="value font-weight-light px-3 py-2">
            {{scmData[field.key] || "—"}}
          </div>
        </template>
      </template>
    </v-layout>
    <v-layout class="px-4 py-2" v-if="isUncompleted">
      <template v-if="buttonsSetName == 'verification'">
        <v-btn color="#f43838" dark @click="reject">Reject</v-btn>
        <v-btn color="#2a63d5" dark @click="verify">Verify</v-btn>
      </template>
      <template v-else-if="buttonsSetName == 'ready_for_submission'">
        <v-btn color="#2a63d5" class="single" dark @click="submit">Submit To Blockchain</v-btn>
      </template>
      <template v-else-if="buttonsSetName == 'rejected'">
        <v-btn color="#2a63d5" class="single" dark @click="edit">Edit</v-btn>
      </template>
      <template v-else-if="buttonsSetName == 'verification_failed'">
        <v-btn color="#f43838" class="single" dark @click="remove">Delete</v-btn>
      </template>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import * as transactionUtils from '@/utils/transaction'
import * as userUtils from '@/utils/user'

export default {
  name: 'TransactionCard',
  props: {
    transaction: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      scmData: { },
    }
  },
  computed: {
    ...mapGetters(['profile']),
    scmFields () {
      return this.$store.getters['scmFields/scmFields'][this.transaction.code.campaign]
    },
    buttonsSetName () {
      const txnStatusDescription = transactionUtils.getStringStatus(this.transaction.status)
      return userUtils.isActingParticipant(this.profile.role, txnStatusDescription) && txnStatusDescription
    },
    // can be removed?
    isUncompleted () {
      if (!Object.keys(this.transaction).length) return true
      return transactionUtils.isUncompleted(this.transaction)
    },
    transactionAndSCM () {
      return this.scmFields && this.transaction && this.transaction.value
    },
  },
  methods: {
    reject () {
      this.$store.dispatch('transactions/rejectTransaction', this.transaction.id)
    },
    verify () {
      this.$store.dispatch('transactions/verifyTransaction', this.transaction.id)
    },
    submit () {
      this.$store.dispatch('transactions/submitTransaction', this.transaction.id)
    },
    remove () {
      this.$store.dispatch('transactions/deleteTransaction', this.transaction.id)
    },
    edit () {
      this.$emit('edit', this.scmData)
    }
  },
  watch: {
    transactionAndSCM () {
      if (this.transaction.value && this.scmFields) {
        const scmData = JSON.parse(this.transaction.value)
        this.scmFields.forEach(field => {
          this.$set(this.scmData, field.key, scmData[field.key])
        })
        this.$set(this.scmData, 'transaction_id', this.transaction.transactionId)
        this.$set(this.scmData, 'transaction_id_internal', this.transaction.id)
        this.$set(this.scmData, 'description_tx', this.transaction.description)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.code-card{
  position: relative;
}

.hash {
  font-family: monospace;
  word-break: break-all;
  text-decoration: none;
  color: #2a63d5;
}

.edit-btn{
  position: absolute;
  top: 0px;
  right: 0px;
}

.infos-container{
  padding: 10px 25px;
}

.label{
  color: #858585;
  font-size: 12px;
}

.value{
  background: white;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.certificate .label{
  background: white;
}

.rotate{
  transform: rotateX(180deg)
}

.expand-header{
  padding: 5px 15px;
  background: #fafafa;
  cursor: pointer;
}

.expand-content{
  transition: 0.5s;
  max-height: 0;
  overflow: hidden;
}

.show-content{
  max-height: 300px;
}

.caption{
  color: #888888;
  margin-bottom: 10px;
}

.divider:after, .divider:before {
  width: 75px;
  height: 1px;
  background-color: #8888887a;
  content: "";
  display: block;
  position: relative;
}

.divider:after {
  left: 78px;
  bottom: 10px;
}

.divider:before {
  left: 235px;
  top: 10px;
}

.code-card .v-btn {
  height: 30px;
  width: 140px;
}

.code-card .v-btn.single {
  width: 300px;
}

</style>
